/**
 * Разбор входного URL вьюера. Контракт (ADR 0004, неизменен навсегда):
 * /v/{venue}?a={anchor}&to={poi}
 * Паттерн «мусор → null» — из TecTactic fromUri. Хост не проверяем: страница
 * уже отдана с нашего домена; сборка исходящих ссылок — venueUrl() в @app/brand.
 */

export interface VenueLink {
  readonly venueId: string
  readonly anchor?: string | undefined
  readonly to?: string | undefined
}

export function parseVenuePath(pathname: string, search: string): VenueLink | null {
  const match = pathname.match(/^\/v\/([\w-]+)\/?$/)
  const venueId = match?.[1]
  if (!venueId) return null
  const params = new URLSearchParams(search)
  return {
    venueId,
    anchor: params.get('a') ?? undefined,
    to: params.get('to') ?? undefined,
  }
}
